import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import copyIcon from "../imgs/copy.svg";
import { copyCommandToClipboard } from "../copyCommandToClipboard";
import { MergeClassNames } from "../styleHelper";
import { TextPropertyLine } from "../fluent/hoc/propertyLines/textPropertyLine";
import { LinkPropertyLine } from "../fluent/hoc/propertyLines/linkPropertyLine";
import { ToolContext } from "../fluent/hoc/fluentToolWrapper";
import { BooleanBadgePropertyLine } from "../fluent/hoc/propertyLines/booleanBadgePropertyLine";
export class TextLineComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    onLink() {
        if (this.props.url) {
            window.open(this.props.url, "_blank");
            return;
        }
        if (!this.props.onLink) {
            return;
        }
        this.props.onLink();
    }
    copyFn() {
        const onCopy = this.props.onCopy;
        const val = this.props.value;
        if (onCopy === true && val !== undefined) {
            return () => val;
        }
        else if (typeof onCopy === "function") {
            return onCopy;
        }
        return undefined;
    }
    renderContent(isLink, tooltip) {
        if (this.props.ignoreValue) {
            return null;
        }
        if (isLink) {
            return (_jsx("div", { className: "link-value", title: tooltip, onClick: () => this.onLink(), children: this.props.url ? "doc" : this.props.value || "no name" }));
        }
        return (_jsx("div", { className: "value", title: tooltip, style: { color: this.props.color ? this.props.color : "" }, children: this.props.value || "no name" }));
    }
    renderOriginal(isLink, tooltip) {
        return (_jsxs("div", { className: MergeClassNames(["textLine", ["underline", this.props.underline], this.props.additionalClass, ["icon", this.props.onCopy]]), children: [this.props.icon && _jsx("img", { src: this.props.icon, title: this.props.iconLabel, alt: this.props.iconLabel, className: "icon" }), _jsx("div", { className: "label", title: this.props.tooltip ?? this.props.label ?? "", children: this.props.label ?? "" }), this.renderContent(isLink, tooltip), this.props.onCopy && (_jsx("div", { className: "copy hoverIcon", onClick: () => {
                        const copyFn = this.copyFn();
                        if (copyFn) {
                            copyCommandToClipboard(copyFn());
                        }
                    }, title: "Copy to clipboard", children: _jsx("img", { src: copyIcon, alt: "Copy" }) }))] }));
    }
    renderFluent(isLink, tooltip) {
        const sharedProps = {
            tooltip,
            label: this.props.label || "",
            onCopy: this.copyFn(),
        };
        if (isLink) {
            return _jsx(LinkPropertyLine, { ...sharedProps, value: this.props.url ? "doc" : this.props.value || "no name", url: this.props.url, onLink: this.props.onLink });
        }
        else if (this.props.value === "Yes" || this.props.value === "No") {
            return _jsx(BooleanBadgePropertyLine, { label: this.props.label || "", value: this.props.value === "Yes" });
        }
        else {
            return _jsx(TextPropertyLine, { ...sharedProps, value: this.props.value || "" });
        }
    }
    render() {
        const tooltip = this.props.tooltip ?? this.props.value ?? this.props.label ?? "";
        const isLink = this.props.onLink !== undefined || this.props.url !== undefined;
        return _jsx(ToolContext.Consumer, { children: ({ useFluent }) => (useFluent ? this.renderFluent(isLink, tooltip) : this.renderOriginal(isLink, tooltip)) });
    }
}
//# sourceMappingURL=textLineComponent.js.map